export const environment = {
  production: true,
  disableEasyAuth: true,
  productionURL: "%%productionURL%%", // Azure endpoint/cnd 
  sessionStandAloneTime: "%%sessionStandAloneTime%%",
  loggingTargets: "%%loggingTargets%%",
  auth0Config: "%%auth0Config%%",
  contentful: "%%contentful%%",
  googleAnalyticsID: "%%googleAnalyticsID%%",
  proxy: "%%proxy%%",
  notificationConfig: "%%notificationConfig%%",
  clientDocs: "%%clientDocs%%",
  hideDatesPriorToDate: "%%hideDatesPriorToDate%%",
  assetsFolderPath: "%%assetsFolderPath%%",
  externalUris: "%%externalUris%%",
  ars: "%%ars%%",
  appsUrl: "%%appsUrl%%",
  appName: "%%appName%%",
  notfound: "%%notfound%%",
  Environment: '%%Environment%%',
  showLoginBanner: '%%showLoginBanner%%',
  showCommingledExperience: "%%showCommingledExperience%%"
};
